//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDelete, fetchDetail } from '@/api/PMS/customerService/leaseContract/contractList';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      areaId: '',
      title: '',
      contractState: '',
      // 合同状态
      childData: {
        leaseType: 1
      },
      multipleSelection: [],
      houseList: [],
      parkingLotList: [],
      houseBillList: [],
      standardList: [],
      parkLotBillList: [],
      loading: false,
      dialogFormVisible: false,
      dialogCustomerVisible: false,
      dialogHistoryVisible: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.getDetail(this.keyValue);
    },
    getDetail: function getDetail(id) {
      var _this = this;

      this.listLoading = true;
      fetchDetail({
        id: id
      }).then(function (res) {
        if (res.data.code === 200) {
          var data = res.data.data;
          _this.parkLotBillList = data.chargeRecordUnsettleds;
          _this.houseBillList = data.chargeRecordUnsettleds;
          var childData = {
            leaseType: data.leaseType,
            areaGroupId: data.areaGroupId,
            customerId: data.customerId,
            contractNo: data.contractNo,
            contractName: data.contractName,
            beginDate: data.beginDate,
            endDate: data.endDate,
            remark: data.remark
          };
          _this.childData = childData;
          _this.houseList = data.leaseContractResourceVos;
          _this.parkingLotList = data.leaseContractResourceVos;

          if (data.leaseContractTeamsVos && data.leaseContractTeamsVos.length > 0) {
            _this.standardList = data.leaseContractTeamsVos[0].leaseContractStandardVos;
          }
        }

        _this.listLoading = false;
      });
    },
    handleUpdate: function handleUpdate() {
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    handleDelete: function handleDelete() {
      var _this2 = this;

      this.$confirm('你确定是要删除该房间, 是否继续?', '提示').then(function () {
        fetchDelete([_this2.keyValue]).then(function (response) {
          _this2.$emit('handDetailCancle');

          _this2.Alert({
            alertType: 'delete'
          });
        });
      });
    },
    handCancle: function handCancle() {
      this.dialogFormVisible = false;
      this.dialogCustomerVisible = false;
      this.dialogHistoryVisible = false;
    }
  }
};